import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "../common/Util.css";
import apps from "../../assets/svg/apps.svg";
import vendorLogo from "../../assets/svg/vendorLogo.svg";
import chevronDown from "../../assets/svg/dropDown.svg";
import Dropdown from "react-bootstrap/Dropdown";
import dashboardIcon from "../../assets/svg/dashboard.svg";
import dashboardActiveIcon from "../../assets/svg/dashboardActive.svg";
import productsIcon from "../../assets/svg/products.svg";
import productsActiveIcon from "../../assets/svg/productActiveICon.svg";
import vendorsIcon from "../../assets/svg/vendors.svg";
import vendorsIconActive from "../../assets/svg/vendorsActive.svg";
import requestIcon from "../../assets/svg/purchaseRequest.svg";
import quotationIcon from "../../assets/svg/purchaseQuatation.svg";
import orderIcon from "../../assets/svg/purchaseOrder.svg";
import orderActiveIcon from "../../assets/svg/purchaseOrderActive.svg";
import historyIcon from "../../assets/svg/vendorHistory.svg";
import paymentIcon from "../../assets/svg/payment.svg";
import paymentSelectIcon from "../../assets/svg/selectPayment_ic.svg";
import receiptIcon from "../../assets/svg/receipt.svg";
import receiptActIcon from "../../assets/svg/recept_act_ic.svg";
import reportIcon from "../../assets/svg/report.svg";
import reportActiveIcon from "../../assets/svg/reportActivIC.svg";
import transaction from "../../assets/svg/transaction.svg";
import transactionActive from "../../assets/svg/transactionActive.svg";
import PurchReqActive from "../../assets/svg/purchase_active_ic.svg";
import logoIc from "../../assets/png/logo_ic.png";
import setup from "../../assets/svg/setup.svg";
import HomePageIc from "../../assets/svg/homepage_ic.svg";
import VendorHisActIc from "../../assets/svg/vendor_his_act_ic.svg";
import PurcQuActive from "../../assets/svg/purchaseQuota_ac_ic.svg";
import { useGlobal } from "../../GlobalContext";
const menuItems = [
  {
    label: "Dashboard",
    path: "/",
    icon: dashboardIcon,
    activeIcon: dashboardActiveIcon,
    moduleName: "Dashboard",
  },

  {
    label: "Products",
    path: "/product",
    icon: productsIcon,
    activeIcon: productsActiveIcon,
    moduleName: "Products",
  },
  {
    label: "Vendors",
    path: "/vendor",
    icon: vendorsIcon,
    activeIcon: vendorsIconActive,
    moduleName: "Vendors",
  },
  {
    label: "Project",
    path: "/project",
    icon: orderIcon,
    activeIcon: orderActiveIcon,
    moduleName: "Project",
  },

  {
    label: "RFQ",
    path: "/pr",
    icon: requestIcon,
    activeIcon: PurchReqActive,
    moduleName: "Purchase Request",
  },
  {
    label: "Purchase Quotation",
    path: "/purchase-quotation",
    icon: quotationIcon,
    activeIcon: PurcQuActive,
    moduleName: "Purchase Quotation",
  },
  {
    label: "Purchase Order",
    path: "/purchase-order",
    icon: orderIcon,
    activeIcon: orderActiveIcon,
    moduleName: "Purchase Order",
  },
  {
    label: "Vendor History",
    path: "/vendor-history",
    icon: historyIcon,
    activeIcon: VendorHisActIc,
    moduleName: "Vendor History",
  },
  {
    label: "Bank Transaction",
    path: "/bank-transaction",
    icon: paymentIcon,
    activeIcon: paymentSelectIcon,
    moduleName: "Bank Transaction",
  },
  // {
  //   label: "Receipt",
  //   path: "/receipt",
  //   icon: receiptIcon,
  //   activeIcon: receiptActIcon,
  //   moduleName: "Receipt",
  // },
  {
    label: "Transactions",
    path: "/transaction",
    icon: transaction,
    activeIcon: transactionActive,
    moduleName: "Transactions",
  },
  {
    label: "Payment",
    path: "/payment",
    icon: paymentIcon,
    activeIcon: paymentSelectIcon,
    moduleName: "Payment",
  },
  {
    label: "Report",
    path: "/report",
    icon: reportIcon,
    activeIcon: reportActiveIcon,
    moduleName: "Report",
  },
];

export const Sidebar = ({ currentfile }) => {
  const navigate = useNavigate();
  const { rolePermissionList, userType, orgImage } = useGlobal();
  const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;
  function checkPermission(menuName, permission) {
    return rolePermissionList.findIndex(
      (element) =>
        element["name"] === menuName &&
        element["menu_permission"] === true &&
        element[permission] === true
    ) > -1
      ? true
      : false;
  }
  return (
    <div
      className="sidebar bg-white"
    // style={{ boxShadow: "5px 0px 10px -2px #00000012" }}
    >
      <div
        className="d-flex mb-3 p-3 align-items-center"
        style={{ position: "relative" }}
      >
        <img
          src={HomePageIc}
          alt="Company Logo"
          className="logo"
          style={{ cursor: "pointer" }}
          onClick={() => {
            window.open(accountsUrl, "_blank", "noopener,noreferrer");
          }}
        />

        {/* CENTER CONTENT */}
        <div
          className="d-flex align-items-center"
          style={{
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            marginLeft: "10px",
          }}
        >
          <img
            src={orgImage || logoIc}
            alt="vendor logo"
            style={{
              width: orgImage ? null : "30px",
              height: "30px",
              objectFit: "contain",
              marginRight: "6px",
            }}
          />
          {!orgImage && <h6 className="fw-bold m-0">Vendor Management</h6>}
        </div>
      </div>

      {/* <img
        src={orgImage != null && orgImage !== "" ? orgImage : TicketLogoSvg}
        alt=""
        className="logo"
        width="62px"
        height="30px"
      /> */}
      <ul className="list-unstyled">
        {menuItems.map((item) => {
          const isActive = currentfile === item.label;
          return (
            <>
              {(checkPermission(item.moduleName, "menu_permission") ||
                item.moduleName === "Bank Transaction") && (
                  <li key={item.path} className="mb-1 d-flex flex-row">
                    <div
                      style={{
                        marginTop: "7px",
                        width: "5px",
                        height: "23px",
                        borderTopRightRadius: "100px",
                        borderBottomRightRadius: "100px",
                        backgroundColor: isActive ? "#4F46E5" : "#FFF",
                      }}
                    ></div>
                    <NavLink
                      to={item.path}
                      style={{
                        marginLeft: "18px",
                        marginRight: "16px",
                      }}
                      className={`d-flex align-items-center gap-2 p-2 rounded fs-13 fw-500 text-decoration-none w-100  ${isActive
                          ? "backgroundActiveGrey textPurple rounded-pill"
                          : "text-dark"
                        }`}
                    >
                      <img
                        src={isActive ? item.activeIcon : item.icon}
                        alt={`${item.label} icon`}
                        style={{ width: "16px", height: "16px" }}
                      />
                      {item.label}
                    </NavLink>
                  </li>
                )}
            </>
          );
        })}
      </ul>

      {(checkPermission("Project", "menu_permission") ||
        checkPermission("Industry", "menu_permission") ||
        checkPermission("Sub Industry", "menu_permission") ||
        checkPermission("Product Group", "menu_permission") ||
        checkPermission("Vendor Grade", "menu_permission")) && (
          <div
            style={{
              cursor: "pointer",
              boxShadow:
                "0px 2px 4px rgba(0,0,0,0.1), 0px -2px 4px rgba(0,0,0,0.05)",
            }}
            onClick={() => {
              navigate("/setup");
            }}
            className="mt-4 bg-white text-black border-0  fs-12 fw-500 d-flex align-items-center justify-content-between w-100 p-2 custom-toggle"
          >
            <div className="d-flex align-items-center gap-2">
              <div className="d-flex align-items-center justify-content-center">
                <img src={setup} alt="setup icon" width={28} height={28} />
              </div>
              <div className="text-start">
                <div className="fw-bold text-dark">Setup</div>
                <div className="text-muted fs-12">Manage your masters</div>
              </div>
            </div>
          </div>
        )}
    </div>
  );
};
